function IsNullOrEmpty(value)
{
  return (value == null) || (value === "") || (value === "null");
}

export default IsNullOrEmpty;